module.exports = __webpack_public_path__ + "static/media/41.55b8b680.png";